/* @flow strict */

/* eslint-disable camelcase */
/* eslint-disable max-params */

import * as React from 'react';
import Credentials from '/client/src/api/Credentials.js';
import { currency } from '/client/src/constants/';
import { format } from '/client/src/utils/amountTransformation';
import { PUT } from '/client/src/api';
import CssPinner from '/client/src/components/csspinner';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import { convertToLocalTime } from '/client/src/utils/jstz';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';

export const columns = (
    rowsFilter: {} | null,
    showPaymentModal?: any,
    handleShowPaymentModal?: any,
    handleShowPaymentModalOrderId?: any,
    showPaymentPurchaseModal?: any,
    handleShowPaymentPurchaseModal?: any,
    editRow: {},
    rowsOrg: {},
    toggleEdit: () => void,
    onHandleFindAndReplaceRowData: () => void,
    sponsors: [],
    setRowsOrg: () => void,
    isNeedShowConfirm: () => void,
    ValidateByEmpty: () => void

): [] => {
  const style = {
    border: '1px solid #cecece',
    borderRadius: '4px',
    lineHeight: '20px',
    padding: '4px .5rem',
    width: '100%'
  };

  const context = React.useContext(EventDetailContainerContext);
  const defContext = React.useContext(DefaultContainerContext);
  const isReadonlyPermission = _.get(context, 'eventDetail.permission', 'Write') === 'Read';
  const time_zone_id = _.get(context, 'eventDetail.time_zone_id', '');

  const _c = [
    {
      selector: '',
      name: '',
      sortable: false,
      type: 'c0',
      sortType: 0,
      cell: (row: {}): React.Element => {
        if (isReadonlyPermission) return null;
        return (
          <span className={editRow && row.id.toString() === _.get(editRow, 'id', 0).toString() ? '' : 'showOnHover'}>
            {(+row.id !== +_.get(editRow, 'id', 0)) ?
              <i
                className="icon icon-pencil"
                style={{
                  color: '#e22853',
                  fontSize: '16px'
                }}
                onClick={() => {
                  if (_.size(editRow) && _.size(rowsOrg) && isNeedShowConfirm(editRow, rowsOrg)) {
                    // trigger open confirm modal when click in the same handler
                    $('body').click();
                  }

                  if (!_.size(editRow) && !_.size(rowsOrg) || !isNeedShowConfirm(editRow, rowsOrg)) {
                    const _row = _.clone(row);

                    toggleEdit(row);
                    setRowsOrg(_row);
                  }
                }}
              />
              :
              <i
                className="icon icon-save"
                style={{
                  color: '#e22853',
                  fontSize: '16px'
                }}
                onClick={async () => {
                  const isValid = ValidateByEmpty();

                  if (_.isString(isValid)) {
                    defContext.handleShowSystemDialog(true, {
                      systemDialogType: 'error',
                      systemDialogTitle: 'Oops',
                      systemDialogContent: isValid
                    });
                  } else {
                    CssPinner(document.body, true);

                    try {
                      await PUT(`/api/v1/1/events/${row.event_id}/attendee/${row.id}`, {
                        email_address: editRow.email_address,
                        first_name: editRow.first_name,
                        last_name: editRow.last_name,
                        phone_number: editRow.phone_number,
                        remark: editRow.remark,
                        // sponsor_name: editRow.sponsor_name,
                        sponsor_id: editRow.sponsor_id
                      });
                    } catch (e) {
                      console.error(e);
                      defContext.handleShowSystemDialog(true, {
                        systemDialogType: 'error',
                        systemDialogTitle: 'Oops',
                        systemDialogContent: 'Can\'t save'
                      });
                    }

                    CssPinner(document.body, false);
                    toggleEdit(null);
                    setRowsOrg({});
                  }
                }}
              />
            }
          </span>
        );
      }
    },
    {
        selector: 'first_name',
        name: 'First Name',
        sortable: true,
        type: 'c2',
        sortType: 1,
        cell: (row: {}): React.Element<'div'> => {
          const [fName, setFName] = React.useState(row.first_name || '');

          if (!editRow || row && row.id && row.id.toString() !== editRow.id.toString()) {
            return fName;
          }

          return (
            <input
              type="text"
              value={fName}
              style={style}
              onBlur={() => {
                onHandleFindAndReplaceRowData(row, {
                  ...row,
                  first_name: fName,
                  last_name: row.last_name,
                  email_address: row.email_address,
                  phone_number: row.phone_number,
                  sponsor_name: row.sponsor_name,
                  sponsor_id: row.sponsor_id
                });
              }}
              onChange={(e: any) => {
                setFName(e.target.value);
              }}
            />
          );
        }
    },
    {
        selector: 'last_name',
        name: 'Last Name',
        sortable: true,
        type: 'c3',
        sortType: 2,
        cell: (row: {}): React.Element<'div'> => {
          const [lName, setLName] = React.useState(row.last_name || '');

          if (!editRow || row && row.id && row.id.toString() !== editRow.id.toString()) {
            return lName;
          }

          return (
            <input
              type="text"
              value={lName}
              style={style}
              onBlur={() => {
                onHandleFindAndReplaceRowData(row, {
                  ...row,
                  first_name: row.first_name,
                  last_name: lName,
                  email_address: row.email_address,
                  phone_number: row.phone_number,
                  sponsor_name: row.sponsor_name,
                  sponsor_id: row.sponsor_id
                });
              }}
              onChange={(e: any) => {
                setLName(e.target.value);
              }}
            />
          );
        }
    },
    {
        selector: 'attendance_event_count',
        name: 'Attendance Count',
        sortable: true,
        type: 'c26',
        sortType: 3,
        cell: (row: {}): string => {
          if (+row.attendance_event_count === 1) {
            return 'First Event!';
          }

          return row.attendance_event_count && `${row.attendance_event_count} events`;
        }
    },
    {
        selector: 'ticket.name',
        name: 'Ticket Type',
        sortable: true,
        cell: (row: any): any => {
          if (!row.ticket) {
            return '';
          }

          return (
            <a
              target="_blank"
              rel="noreferrer noopener"
              style={{
                textDecoration: 'none'
              }}
              href={`${process.env.PROXY_API_HOST}/1/events/${row.event_id}/attendees/${row.id}/print_ticket?access_token=${Credentials.getToken()}`}
            >
              {row.ticket.name}
            </a>
          );
        },
        type: 'c7',
        sortType: 4
    },
    {
        selector: 'order.customer_email_address',
        name: 'Email',
        sortable: true,
        type: 'c5',
        sortType: 5,
        cell: (row: {}): React.Element<'div'> => {
          const [email, setEmail] = React.useState(row.email_address || '');

          if (!editRow || row && row.id && row.id.toString() !== editRow.id.toString()) {
            return email;
          }

          return (
            <input
              type="email"
              value={email}
              style={style}
              onBlur={() => {
                onHandleFindAndReplaceRowData(row, {
                  ...row,
                  first_name: row.first_name,
                  last_name: row.last_name,
                  email_address: email,
                  phone_number: row.phone_number,
                  sponsor_name: row.sponsor_name,
                  sponsor_id: row.sponsor_id
                });
              }}
              onChange={(e: any) => {
                setEmail(e.target.value);
              }}
            />
          );
        }
    },
    {
        selector: 'phone_number',
        name: 'Phone',
        sortable: true,
        type: 'c6',
        sortType: 6,
        cell: (row: {}): React.Element<'div'> => {
          const [phone, setPhone] = React.useState(row.phone_number || '');

          if (!editRow || row && row.id && row.id.toString() !== editRow.id.toString()) {
            return phone;
          }

          return (
            <input
              type="tel"
              value={phone}
              style={style}
              onBlur={() => {
                onHandleFindAndReplaceRowData(row, {
                  ...row,
                  first_name: row.first_name,
                  last_name: row.last_name,
                  email_address: row.email_address,
                  phone_number: phone,
                  sponsor_name: row.sponsor_name,
                  sponsor_id: row.sponsor_id
                });
              }}
              onChange={(e: any) => {
                setPhone(e.target.value);
              }}
            />
          );
        }
    },
    {
        selector: 'remark',
        name: 'Notes',
        sortable: true,
        type: 'c8',
        sortType: 7,
        cell: (row: {}): React.Element<'div'> => {
          const [notes, setNotes] = React.useState(row.remark || '');

          if (!editRow || row && row.id && row.id.toString() !== editRow.id.toString()) {
            return notes;
          }

          return (
            <input
              type="tel"
              value={notes}
              style={style}
              onBlur={() => {
                onHandleFindAndReplaceRowData(row, {
                  ...row,
                  first_name: row.first_name,
                  last_name: row.last_name,
                  email_address: row.email_address,
                  remark: notes,
                  sponsor_name: row.sponsor_name,
                  sponsor_id: row.sponsor_id
                });
              }}
              onChange={(e: any) => {
                setNotes(e.target.value);
              }}
            />
          );
        }
    },
    {
      selector: 'order.paid_time_utc',
      name: 'Date Purchased',
      sortable: true,
      cell: (row: {}): React.Element<'div'> => {
        return convertToLocalTime(_.get(row, 'order.paid_time_utc', ''), time_zone_id, 'MM/DD/YY h:mm a z');
      },
      type: 'c4',
      sortType: 8
    },
    {
        selector: 'order.type',
        name: 'Payout',
        sortable: true,
        cell: (row: any): any => {
          return `${row.order ? row.order.type : ''}`;
        },
        type: 'c15',
        sortType: 9
    },
    {
        selector: 'order.customer_first_name',
        name: 'Purchaser',
        sortable: true,
        cell: (row: any): any => {
          return `${row.order ? `${row.order.customer_first_name} ${row.order.customer_last_name}` : ''}`;
        },
        type: 'c1',
        sortType: 10
    },
    {
        selector: 'ticket.price',
        name: 'Ticket Price',
        sortable: true,
        cell: (row: any): any => {
          return row.order && format(currency[row.order.currency], row.ticket ? row.ticket.price : 0);
        },
        type: 'c9',
        sortType: 11
    },
    {
        selector: 'order.currency',
        name: 'Payment Currency',
        sortable: true,
        cell: (row: any): any => {
          return `${row.order ? row.order.currency : ''}`;
        },
        type: 'c10',
        sortType: 12
    },
    {
        selector: 'ticket.discount_amount',
        name: 'Discount Amount',
        sortable: true,
        cell: (row: any): any => {
          return row.order && format(currency[row.order.currency], row.discount_amount);
        },
        type: 'c11',
        sortType: 13
    },
    {
        selector: 'ticket.tax',
        name: 'Tax',
        sortable: true,
        cell: (row: any): any => {
          return row.order && format(currency[row.order.currency], row.ticket ? row.ticket.tax : 0);
        },
        type: 'c12',
        sortType: 14
    },
    {
        selector: 'ticket.merchant_fee',
        name: 'Your Unit Service Fee',
        sortable: true,
        cell: (row: any): any => {
          return row.order && format(currency[row.order.currency], row.ticket ? row.ticket.merchant_fee : 0);
        },
        type: 'c13',
        sortType: 15
    },
    {
        selector: 'ticket.payment_method_additional_fee',
        name: 'Sparxo and CC Processing',
        sortable: true,
        cell: (row: any): any => {
          return row.order && format(currency[row.order.currency], row.sparxo_processing_fee);
        },
        type: 'c14',
        sortType: 16
    },
    {
        selector: 'ticket.fee_type',
        name: 'Fee Type',
        sortable: true,
        cell: (row: any): any => {
          return `${row.ticket ? row.ticket.fee_type : ''}`;
        },
        type: 'c24',
        sortType: 17
    },
    {
        selector: 'check_code',
        name: 'Ticket Code',
        sortable: true,
        cell: (row: any): any => {
          return `${row.check_code ? row.check_code : ''}`;
        },
        type: 'c16',
        sortType: 18
    },
    {
        selector: 'order.card_last4',
        name: 'Last 4 cc',
        sortable: true,
        cell: (row: any): any => {
          return `${row.order ? row.order.card_last4 || '' : ''}`;
        },
        type: 'c17',
        sortType: 19
    },
    {
        selector: 'order.referral_user_name',
        name: 'Referred By',
        sortable: true,
        cell: (row: any): any => {
          return `${row.order ? row.order.referral_user_name || '' : ''}`;
        },
        type: 'c18',
        sortType: 20
    },
    {
        selector: 'ticket.coupon_code',
        name: 'Discount Code',
        sortable: true,
        cell: (row: any): any => {
          return row.discount_coupon_code;
        },
        type: 'c19',
        sortType: 21
    },
    {
      selector: 'sponsor_id',
      name: 'Sponsor',
      sortable: false,
      cell: (row: {}): React.Element<'div'> => {
        // const [sponsor, setSponsor] = React.useState(row.sponsor_name || '');
        const [sponsorId, setSponsorId] = React.useState(row.sponsor_id || null);

        if (!editRow || row && row.id && row.id.toString() !== editRow.id.toString()) {
          return row.sponsor_name;
        }

        React.useEffect(() => {
          onHandleFindAndReplaceRowData(row, {
            ...row,
            first_name: row.first_name,
            last_name: row.last_name,
            email_address: row.email_address,
            remark: row.remark,
            sponsor_id: sponsorId,
            sponsor_name: _.get(_.find(sponsors, (s: {}): string => s.id === sponsorId), 'name', '')
          });
        }, [sponsorId]);

        return (
          <select
            value={sponsorId || ''}
            style={style}
            onChange={(e: any) => {
              setSponsorId(e.target.value);
            }}
          >
            <option value='' />
            {_.map(sponsors, (s: {}, si: number): React.Element<'option'> => {
              return (
                <option
                  value={s.id}
                  key={`sponsorItem-${si}-${s.id}`}
                >{s.name}</option>);
            })}
          </select>
        );
      },
      type: 'c27',
      sortType: 27
    },
    {
        selector: 'order.payment_status',
        name: 'Payment Status',
        sortable: true,
        cell: (row: any): any => {
          return `${row.order ? row.order.payment_status || '' : ''}`;
        },
        type: 'c20',
        sortType: 22
    },
    {
        selector: 'email_status',
        name: 'Ticket Status',
        sortable: true,
        cell: (row: any): any => {
          return `${row.email_status ? row.email_status || '' : ''}`;
        },
        type: 'c21',
        sortType: 23
    },
    {
        selector: 'has_checked',
        name: 'Check-in Status',
        sortable: true,
        cell: (row: any): any => {
          return `${row.has_checked ? 'Checked' : 'Not Checked'}`;
        },
        type: 'c25',
        sortType: 24
    },
    {
        selector: 'order.amount_refund',
        name: 'Refunded',
        sortable: true,
        cell: (row: any): any => {
          return row.order && format(currency[row.order.currency], row.refund_amount || 0);
        },
        type: 'c22',
        sortType: 25
    },
    {
        selector: 'last_modification_time',
        name: 'Update Time',
        sortable: true,
        cell: (row: {}): React.Element<'div'> => {
          return convertToLocalTime(_.get(row, 'last_modification_time', ''), time_zone_id, 'MM/DD/YY h:mm a z');
        },
        type: 'c23',
        sortType: 26
    },
    {
      selector: 'q_r_code_data',
      name: 'QR Code',
      sortable: false,
      type: 'c28',
      sortType: 24,
      cell: (row: any): any => {
        return `${row.q_r_code_data || ''}`;
      }
    }
  ];

  const filteredColumns =  _.filter(_c, (_ci: {}): {} => rowsFilter[_ci.type]);

  // Always show Edit btn, First name and Last name, Sponsor
  filteredColumns.unshift(_c[0]);
  filteredColumns.unshift(_c[1]);
  filteredColumns.unshift(_c[2]);
  // filteredColumns.unshift(_c[22]);
 if (filteredColumns.length && filteredColumns.length >= 2) { // hack for smooth skeleton animation
  const sorted =  _.sortBy(filteredColumns, (fc: {}): {} => fc.sortType);

  return _.uniqBy(sorted, (e): any => {
  return e.type;
});
 }
  return [];
};
